import {
  SpecialButtonLink,
  SpecialOutlineButton,
} from '@chegg-wt/core/theme/fanta/button'
import styled from 'styled-components'
import { ChevronIcon, colors, spacing } from '@chegg-ui/theme'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const ButtonBar = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row nowrap;

  & > * {
    margin: ${spacing.px4} ${spacing.px4};
    flex-basis: 25%;
    flex-grow: 0;
  }

  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), -1)}) {
    flex-flow: row wrap;

    & > * {
      margin: ${spacing.px4} ${spacing.px4};
      flex-basis: calc(50% - 20px);
    }
  }

  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), -1)}) {
    & > * {
      margin: ${spacing.px4} 0;
      flex-basis: 100%;
    }
  }
`

export const ButtonLink = styled(SpecialButtonLink)`
  flex-grow: 0;
`

export const SelectedTrigger = styled(SpecialButtonLink)`
  position: relative;
  text-overflow: ellipsis;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 ${spacing.px24};
  & > span {
    width: 100%;
  }
`

export const Trigger = styled(SpecialOutlineButton)`
  position: relative;
  text-overflow: ellipsis;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 ${spacing.px24};
  & > span {
    width: 100%;
  }
`

export const ButtonText = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.Colors.primaryColor};
`

export const OutlinedButtonText = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #fffff;
`

export const Chevron = styled(ChevronIcon)`
  margin-top: ${spacing.px4};
  vertical-align: middle;
`

export const GroupTitle = styled.span`
  height: 36px;
  margin-left: 5px;
  margin-bottom: 8px;

  font-family: Aspira;
  font-size: 20px;
  line-height: 36px;
  font-weight: bold;

  color: ${colors.dark};
`
